import { Controller } from 'stimulus';

const HIDE_CLASS = 'hidden';

export default class extends Controller {
  show() {
    this.element.classList.remove(HIDE_CLASS);
  }

  hide() {
    this.element.classList.add(HIDE_CLASS);
  }
}
